export const getAbbrFigure = (n: number) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return `${+(n / 1e3).toFixed(1)}K`;
  if (n >= 1e6 && n < 1e9) return `${+(n / 1e6).toFixed(1)}M`;
  if (n >= 1e9 && n < 1e12) return `${+(n / 1e9).toFixed(1)}B`;
  if (n >= 1e12) return `${+(n / 1e12).toFixed(1)}T`;
  return n;
};

export const getFeeRangeText = (lowerRange: number, upperRange: number) => {
  let range = "";
  if (lowerRange === 0 && upperRange === 0) {
    range = "All assets";
  } else if (lowerRange === 0) {
    range = `Up to $${getAbbrFigure(upperRange)}`;
  } else if (upperRange === 0 || upperRange === -1) {
    range = `Above $${getAbbrFigure(lowerRange)}`;
  } else {
    range = `$${getAbbrFigure(lowerRange)}-$${getAbbrFigure(upperRange)}`;
  }
  return range;
};

// formats number to currency with / without $
export const formatCurrencyNumber: (
  arg0: number,
  arg1?: boolean,
  fractionDigits?: number
) => string = (value, prefix = false, fractionDigits = 0) => {
  // eslint-disable-next-line prefer-destructuring
  let val = value?.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  if (fractionDigits === 0) {
    const [newVal] = val.split(".");
    val = newVal;
  }

  if (prefix) return val;
  return val.replace("$", "");
};

export const sanitizeHTMLTags = (str: string) => {
  if (str) {
    return str.replace(/(<([^ \d>]+)>)/gi, " ");
  }
  return "";
};

export const formatDate = (value: string): string => {
  if (!value) return "";
  try {
    const date = new Date(value);
    return `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}`;
  } catch {
    return value;
  }
};

export const isTodayDate = (date: Date) => {
  const tomorrow = new Date();

  if (
    formatDate(tomorrow as unknown as string) ===
    formatDate(new Date(date) as unknown as string)
  ) {
    return true;
  }

  return false;
};
